import React from 'react';
import { View, TouchableOpacity, StyleSheet, Text, ScrollView, Dimensions } from 'react-native';
import { Entypo, EvilIcons, Feather, FontAwesome, Ionicons, Octicons, } from '@expo/vector-icons';
import {AppMain, FontInfo, ReturnTypes } from '../~Utilities/Constants';
import Popup from './Popup';
import TextInputEx from '../C_Text/TextInputEx';
import { Connection, ConnectionMkt, ConnectionOrd } from '../~Utilities/Connection';
import RNPickerSelect from "react-native-picker-select";
import Utilities from '../~Utilities/Utilities';

/*   ---------------------------------------------------------------------   */

export interface IAbout
{
  text:         string;
  sFromToken? : string;
}

/*   ---------------------------------------------------------------------   */

export default class About extends React.Component
 {
   public oTxtSearch : TextInputEx | null = null;
   public oPopup     : Popup       | null = null;
   
   /*   -------------------------------------------------------------------   */

   state : IAbout = {text:"", sFromToken: undefined}

   /*   -------------------------------------------------------------------   */
   
    constructor(props)
    {
    super(props);

    this.Show             = this.Show.bind(this);
    this.Hide             = this.Hide.bind(this);
    this.HideNoAnimation  = this.HideNoAnimation.bind(this);

    this.state = {text: "", sFromToken: AppMain.sDef_Symbol};
    }

    /*   ---------------------------------------------------------------------   */

    Show(sText : string = "")
    {
    this.oPopup?.Show();
    this.oTxtSearch?.SetFocus(); 

    if (this.state.text != sText)
      this.setState({text:sText});

    if ((!AppMain.sDef_Symbol || !Connection.oStore.has(AppMain.sDef_Symbol)) 
         && Connection.oSettings.length > 0)
      {
      ConnectionOrd.SetDefSymbol(Connection.oSettings[0].token);
      }

    //this.forceUpdate();
    }

    /*   ---------------------------------------------------------------------   */

    Hide()
    {
    this.oPopup?.Hide();
    }

    /*   ---------------------------------------------------------------------   */

    HideNoAnimation()
    {
    this.oPopup?.HideNoAnimation();
    }

    /*   ---------------------------------------------------------------------   */

    componentDidMount() 
    {
    }

    componentWillUnmount() 
    {
    }

   /*   ---------------------------------------------------------------------   */ 
   
    componentDidUpdate()
    {
    }

   /*   ---------------------------------------------------------------------   */ 

   GetSymbols()
   {
     let oSymbols = new Array(0);
 
     for (let [key, value] of Connection.oStore.entries())
       {
        oSymbols.push({label:value.token, value:key, key:key, color:"black"});
 
       //Utilities.Sendlog("adding key: " + key);
       }
 
     // if (!this.state.pos_data)
     //   {
     //   let oPosData = this.GetData();
 
     //   if (oPosData != undefined)
     //     this.setState({pos_data:oPosData});
 
     //   Utilities.Sendlog("acc key: " + oPosData?.acc_key + " size: " + oAccs.length);
     //   }
 
     //if (oAccs.length == 0)
     //  oAccs.push({label:"21", value:"2", key:"2"});
 
     return(oSymbols);
   }
 
   /*   -------------------------------------------------------------------   */
 
   render() 
   {
   if (!ConnectionMkt.IsLoggedIn())  
   return(null);

   else return(
    <Popup ref={node => { this.oPopup = node; }} > 
    <View style={{backgroundColor:FontInfo.sBackgroundTp, borderRadius:20, minHeight:370,
                        maxHeight:370, width:Utilities.WIDTH }}>
    <ScrollView style={{flex:1, paddingHorizontal:20, marginVertical:15, backgroundColor:'transparent', 
                        } }>
    <Text style={[FontInfo.appStyles.txt_normal, 
                  {fontSize:FontInfo.iFontSize+2, color:FontInfo.sForeground }]}>
{
`v2.5.0.0
new:
event contracts supporting bigger size and additional expiries.

fix:
updating some charts on new symbol additions.

v2.4.0.0
queue position (beta) is available for live orders 
on Test (beta) gateway.
to use, tap on an order.
use with caution: info displayed may not be accurate.
tap on the queue info to switch from qty to order queue.
updated systems, Test (beta) gateway is available.
more efficient logging mechanism.

fix:
showing neutral candles.
error on loading indicators on empty chart.
saving and retrieving gateways.
keeping selected orders in the order book on refresh

v2.3.0.0
new indicators.
updated window settings.
additional logs.

fix:
centering issues in the order book.
chart scrolling in web.
chart refresh issue on reorder/delete symbols.
updating 1hr and 1 day charts.
keeping the selection on resize/rotate screen.
updating modified bracket/linked orders in the order book.

v2.2.0.0
new:
chart ⚙️ reveals new options: candlesticks, indicators, etc. 
use ? → Copy Log to copy the current app info.
updated oco order line margins.
order operations are tagged by the originator window.

fix:
slow loading due to a framework issue.
selecting orders to modify in the order book.

v2.1.1.0
fix:
additional checks done to fix a connection issue.

v2.1.0.0
new:
bracket and oco orders are linked.
option to expand order book display area.
one-click enable/disable bracket settings
some of the order confirm settings are retained.
newly added symbols also inherit order settings.

fix:
color of 0 symbol pnl.
fixes order remarks area overflow.
buy stop order indicator in order book.
order book loading issues after login.
fixes an http error

v2.0.1.0
fix:
Reconnection sometimes taking too long.
Retaining the newly added symbol.
Bracket leg order text.

v2.0.0.0
new:
Bracket Orders.
Tap [ ] when placing order. 
Default can be set in symbol ⚙️ 

OCO orders.
Tap an order in the order book and use 🔗
This links all matching orders with same qty.
Long tap to select multiple specific orders.

Cancel After and Cancel At
Tap options when placing order. 
Default can be set in symbol ⚙️

Auto Reconnection ☰ → ⚙️
Default is 1 min. 
Set 5 min to make the app stay longer.

Manage Accounts ☰ → 👤
See closed/open p&l, position and orders.
Cancel All and Exit Position.

Symbol Defaults
Select a symbol setting to use when adding new.

5 new trade buttons in the order book.
Join Bid, Join Bid & Ask, Join Ask, 
Buy At Ask and Sell At Bid.

Open order count is colored by side.

Updated p&l coloring.

Updated ☰ → ?
Connection info. Release notes.

Option to disable event trading advert ☰ → ⚙️

Confirm action setting is retained.

Last menu page is retained.

Error alerts for failed order operations.

fix:
Connection issues.
Focus issue in add symbol.
Order Book centering on reconnection.
Account handling when gateway is far.
`}
    </Text>
    </ScrollView>
    </View>
    </Popup>
    );

     }
}

/*   =====================================================================   */

function GetPickerStyles()
{
return(

  StyleSheet.create({
    inputWeb: {
      alignSelf:'center',
      fontFamily: FontInfo.iFont >= 0? FontInfo.Fonts[FontInfo.iFont].normal : undefined,
      fontSize: FontInfo.iFontSize + 2,
      //fontWeight:'bold',
      //paddingVertical: 12,
      //paddingLeft: 40,
  
      // marginLeft:5,
      //width:200,
      //marginVertical:20,

      //paddingLeft: 40,
      marginTop:5,
      height:40,
      minWidth:100,
      textAlign:'center',
  
      marginHorizontal:14,
      marginBottom:8,
      borderWidth: 1,
      borderColor: FontInfo.sBorder,
      borderRadius: 10,
  
      // borderWidth: 1,
      // borderColor: '#EEEEEE',
      // borderRadius: 4,
      // borderBottomWidth:0,
      // borderBottomColor:'#EEEEEE',
      // borderBottomEndRadius:0,
      // borderBottomStartRadius:0,
  
  
      backgroundColor:'transparent',
      color: FontInfo.sForeground,
      //paddingRight: 30, // to ensure the text is never behind the icon
    },
  
    inputIOS: {
      alignSelf:'center',
      fontFamily: FontInfo.iFont >= 0? FontInfo.Fonts[FontInfo.iFont].normal : undefined,
      fontSize: FontInfo.iFontSize + 2,
      //fontWeight:'bold',
      //paddingVertical: 12,
  
  
      //marginVertical:20,
      // marginLeft:5,
      paddingLeft: 30,
      marginTop:10,
      height:40,
      width:272,
      textAlign:'center',
  
      marginHorizontal: FontInfo.iFontSize + 2,
      marginBottom:8,
      borderWidth: 1,
      borderColor: FontInfo.sBorder,
      borderRadius: 10,
      // borderBottomWidth:0,
      // borderBottomColor:'#EEEEEE',
      // borderBottomEndRadius:0,
      // borderBottomStartRadius:0,
  
      backgroundColor:'transparent',
      color: FontInfo.sForeground,
      paddingRight: 30, // to ensure the text is never behind the icon
    },
    inputAndroid: {
      alignSelf:'center',
      fontFamily: FontInfo.iFont >= 0? FontInfo.Fonts[FontInfo.iFont].normal : undefined,
      // alignSelf:'center',
      fontSize: FontInfo.iFontSize + 2,
      //fontWeight:'bold',
      // paddingLeft: 20,
      //paddingVertical: 12,
      //paddingLeft: 30,
  
      //marginVertical:20,
  
      // marginLeft:5,
      paddingLeft: 30,
      marginTop:10,
      height:40,
      width:272,
      textAlign:'center',
  
      marginHorizontal:14,
      marginBottom:8,
      borderWidth: 1,
      borderColor: FontInfo.sBorder,
      borderRadius: 10,
  
      // borderWidth: 0,
      // borderBottomWidth:0,
      // borderBottomColor:'#EEEEEE',
      // borderBottomEndRadius:0,
      // borderBottomStartRadius:0,
      // textAlign:'center',
      // borderWidth: 0.5,
      // borderColor: 'purple',
      // borderRadius: 8,
      backgroundColor:'transparent',
      color: FontInfo.sForeground,
      paddingRight: 30, // to ensure the text is never behind the icon
    },
  
    // button_order:
    // {
    //   backgroundColor:'#f5f6fa',
    //   margin:10,
    //   padding:8,
    //   borderRadius:10,
    //   minWidth:90,
    // },
  
    // text_order:
    // {
    // alignSelf:'center',
    // fontWeight:'bold',
    // color:'red'
    // },
  
  })  

);  
}

/*   =====================================================================   */

const styles = StyleSheet.create({
   search_input: 
  {
  alignSelf:'center',
  //fontSize: FontInfo.iFontSize + 4,
  height: 44,
  width:260,
  borderWidth: 0,
  margin:4,
  padding:10,
  paddingLeft:4,
  borderColor:'white',
  borderBottomWidth:1,
  //borderBottomColor:FontInfo.sDivider,//'#EEEEEE',
  //backgroundColor:'transparent',
  //color:FontInfo.sForeground,
  },

  search_input_invalid: 
  {
  alignSelf:'center',
  //fontSize: FontInfo.iFontSize + 4,
  height: 44,
  borderWidth: 0,
  margin:4,
  padding:10,
  paddingLeft:4,
  width:260,
  borderColor:'white',
  borderBottomWidth:1,
  //borderBottomColor:'red',
  //backgroundColor:'transparent',//'#ffe4e1',
  //color:FontInfo.sForeground,
  },

  button_plus: 
  {
  width:70,
  height:70,
  alignSelf: 'center',
  alignItems: 'center',
  justifyContent: 'center',
  borderRadius: 35,
  backgroundColor: 'cornflowerblue',
  padding:20,
  margin:10,
  },

});